import React from "react";
import EventSection from "./Section/EventSection";
import HistorySection from "./Section/HistorySection";
import MissionSection from "./Section/MissionSection";
import TeamSection from "./Section/TeamSection";

const AboutUsPage = () => {
  return (
    <div className="bg-wce-navy-dark p-11 sm:py-20 px-6 sm:px-16 overflow-hidden">
      <div className="mx-auto">
        <HistorySection />
        <MissionSection />
        <TeamSection />
        <EventSection />
      </div>
    </div>
  );
};

export default AboutUsPage;
